/**
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "../common/namespaces";

import type { GlobalUtils } from "./index.js";

/**
 *
 */
export type Misc = GlobalUtils["misc"];

/**
 *
 */
export const misc: Misc = o_util.misc;

/**
 *
 *
 *
 */
export const getPagecluster: Misc["getPagecluster"] = misc.getPagecluster;

/**
 *
 *
 *
 */
export const guid: Misc["guid"] = misc.guid;

/**
 *
 *
 *
 */
export const isPreview: Misc["isPreview"] = misc.isPreview;

/**
 *
 *
 *
 */
export const isPrivacyPage: Misc["isPrivacyPage"] = misc.isPrivacyPage;

/**
 *
 *
 *
 */
export const isValidMouseButton: Misc["isValidMouseButton"] = misc.isValidMouseButton;

/**
 *
 *
 *
 */
export const nanoid: Misc["nanoid"] = misc.nanoid;

/**
 *
 *
 *
 */
export const urlToLinkObject: Misc["urlToLinkObject"] = misc.urlToLinkObject;

/**
 *
 */
export const setVendorStyle: Misc["setVendorStyle"] = misc.setVendorStyle;

/**
 *
 */
export const isResponsive: Misc["isResponsive"] = misc.isResponsive;
